const React = require('react');
const { createElement: h } = React;
require('./ActionBadge.css');

var colorMap = {
  blue: { bg: '#e8f0fa', border: '#c5d9f0', dot: '#5b9bd5' },
  green: { bg: '#e8f5e8', border: '#c5e0c5', dot: '#5cb85c' },
  orange: { bg: '#fdf3e2', border: '#f0ddb8', dot: '#e8a838' },
  purple: { bg: '#f0eaf8', border: '#d4c5e8', dot: '#9b7dd4' }
};

function ActionBadge(props) {
  var label = props.label;
  var color = props.color || 'blue';
  var colors = colorMap[color] || colorMap.blue;

  return h('div', {
    className: 'action-badge',
    style: { background: colors.bg, borderColor: colors.border }
  },
    h('span', { className: 'action-badge-dot', style: { background: colors.dot } }),
    h('span', { className: 'action-badge-label' }, label)
  );
}

module.exports = ActionBadge;
